import {
  AUTH_INTEGRATION_CREATE,
  AUTH_INTEGRATION_CREATE_REQUEST,
} from 'store/constants/authIntegrationTypes';
import httpSaga from '../httpSaga';
import client from 'sources/api';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authIntegrationSchema } from 'store/schemas/authIntegrationSchema';
import { doneIndicator } from 'store/actions/httpActions';

const WATCH_TYPE = AUTH_INTEGRATION_CREATE_REQUEST;
const TYPE = AUTH_INTEGRATION_CREATE;

export function* createAuthIntegration({ payload }: any) {
  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    TYPE,
    call(client.post, '/auth_integrations', { ...payload }),
    { schema: authIntegrationSchema }
  );

  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, createAuthIntegration);
}

export default function* root() {
  yield all([fork(watch)]);
}
